
import { Injectable, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { MessengerService } from 'src/app/core/service/messenger.service';
import { NGXLogger } from 'ngx-logger';

@Injectable({
  providedIn: 'root'
})
export class QueryBuilderLocalizationService implements OnDestroy
{
  // Localization
  private texts = [];

  // Conditions
  private AND = 0;
  private WHEN = 1;

  // Operators
  private IS = 2;
  private IS_NOT = 3;
  private IS_LESS = 4;
  private IS_LESS_OR_EQUAL = 5;
  private IS_GREATER = 6;
  private IS_GREATER_OR_EQUAL = 7;
  private CONTAINS = 8;
  private NOT_CONTAINS = 9;
  private IN = 10;
  private NOT_IN = 11;
  private LIKE = 12;
  private NOT_LIKE = 13;

  private messengerSubscription: Subscription;

  constructor(
    private translate: TranslateService,
    private messengerService: MessengerService,
    private logger: NGXLogger)
  {
    this.loadLocalizations();
    this.messengerSubscription = this.messengerService.receiveMessage().subscribe({
      next: (message) =>
      {
        if (message && message.type && message.type === 'languageChanged')
        {
          this.logger.info('QueryBuilderLocalizationService message received: Language changed');
          this.loadLocalizations();
        }
      }
    });
  }

  public ngOnDestroy(): void
  {
    if (this.messengerSubscription !== undefined) { this.messengerSubscription.unsubscribe(); }
  }

  /**
   * Provide localized AND condition
   */
  public And(): string
  {
    return this.texts[this.AND];
  }

  /**
   * Provide localized WHEN condition
   */
  public When(): string
  {
    return this.texts[this.WHEN];
  }

  /**
   * Provide localized operator text to display
   */
  public getOperatorText(operator: string): string
  {
    let tag = '';
    switch (operator)
    {
      case '=':
        tag = this.texts[this.IS];
        break;
      case '!=':
        tag = this.texts[this.IS_NOT];
        break;
      case '<':
        tag = this.texts[this.IS_LESS];
        break;
      case '<=':
        tag = this.texts[this.IS_LESS_OR_EQUAL];
        break;
      case '>':
        tag = this.texts[this.IS_GREATER];
        break;
      case '>=':
        tag = this.texts[this.IS_GREATER_OR_EQUAL];
        break;
      case 'contains':
        tag = this.texts[this.CONTAINS];
        break;
      case 'not contains':
        tag = this.texts[this.NOT_CONTAINS];
        break;
      case 'in':
        tag = this.texts[this.IN];
        break;
      case 'not in':
        tag = this.texts[this.NOT_IN];
        break;
      case 'like':
        tag = this.texts[this.LIKE];
        break;
      case 'not like':
        tag = this.texts[this.NOT_LIKE];
        break;
      default:
        tag = operator;
    }
    return tag;
  }

  private loadLocalizations()
  {
    this.translate.get([
      'RULE-NARRATIVE-AND',
      'RULE-NARRATIVE-WHEN',
      'RULE-NARRATIVE-IS',
      'RULE-NARRATIVE-IS-NOT',
      'RULE-NARRATIVE-IS-LESS',
      'RULE-NARRATIVE-IS-LESS-OR-EQUAL',
      'RULE-NARRATIVE-IS-GREATER',
      'RULE-NARRATIVE-IS-GREATER-OR-EQUAL',
      'RULE-NARRATIVE-CONTAINS',
      'RULE-NARRATIVE-NOT-CONTAINS',
      'RULE-NARRATIVE-IN',
      'RULE-NARRATIVE-NOT-IN',
      'RULE-NARRATIVE-LIKE',
      'RULE-NARRATIVE-NOT-LIKE'
    ]).subscribe({
      next: (res) =>
      {
        this.texts = [];
        for (const key in res)
        {
          if ({}.hasOwnProperty.call(res, key))
          {
            this.texts.push(res[key]);
          }
        }
      }
    });
  }
}
